import CellInput from '@Components/ViewWork/Table/ValidationCells/CellInput'
import Pluralize from 'pluralize'
import Button from '@Components/Buttons/Button'
import React from 'react'
import { ICONS } from '@Const/common'
import { GroupedOverclaims } from '@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/components/BulkAmendmentTable'

interface BulkAmendmentTableCellsProps {
    group: GroupedOverclaims
    allowShareEditing: boolean
    toggleShareEditing: (key: string) => void
    updateClaimedShares: (key: string, newClaimedShares: number) => void
    viewGroupDetails: (overclaimIds: number[]) => void
    inReview: boolean
}

const bulkAmendmentTableCells = (props: BulkAmendmentTableCellsProps): React.JSX.Element[] => {
    const { group, allowShareEditing, toggleShareEditing, updateClaimedShares, viewGroupDetails, inReview } = props

    const onCancel = () => {
        updateClaimedShares(group.key, group.initialClaimedShares)
        toggleShareEditing(group.key)
    }

    const tableCells = [
        <CellInput
            readOnly
            name={`${group.key}.works`}
            key={`${group.key}.works`}
            onClick={() => viewGroupDetails(group.groupedOverclaimHeaderIds)}
            defaultValue={Pluralize('work', group.groupedOverclaimHeaderIds.length, true)}
            type="text"
        />,
        <CellInput
            name={`${group.key}.publisherAdminCombo`}
            key={`${group.key}.publisherAdminCombo`}
            defaultValue={group.publisherInfo.combinedName}
            readOnly
            type="text"
        />,
    ]

    if (inReview) {
        tableCells.push(
            <CellInput
                name={`${group.key}.yourShare`}
                key={`${group.key}.yourShare`}
                defaultValue={group.initialClaimedShares}
                readOnly
                type="number"
            />
        )
        tableCells.push(<img src={ICONS.arrow_forward} alt="arrow pointing right" />)
    }
    tableCells.push(
        <CellInput
            name={`${group.key}.claimedShares`}
            key={`${group.key}.claimedShares`}
            defaultValue={group.claimedShares}
            min={0}
            max={100.06}
            readOnly={!allowShareEditing || inReview}
            onValueChanged={(value: string | number) => {
                updateClaimedShares(group.key, Number(value))
            }}
            type="number"
        />
    )
    if (!inReview) {
        tableCells.push(
            <Button
                className={`${group.key}-edit-amendment-button`}
                type={allowShareEditing ? 'secondary' : 'primary'}
                key={`${group.key}-edit-amendment-button`}
                onClick={allowShareEditing ? () => onCancel() : () => toggleShareEditing(group.key)}
                mainColor
            >
                {allowShareEditing ? 'Cancel' : 'Edit'}
            </Button>
        )
    }
    return tableCells
}
export default bulkAmendmentTableCells
